// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/ui/star.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/ui/oval.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.release-notes {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 1em !important;
  color: #333;
  word-wrap: break-word;
  /* -------------------------
      NAV ICON CSS
  -------------------------*/
  /* -------------------------
    NAV ICON CSS END
-------------------------*/
  /*-------------------------
    RESPONSIVE CSS START HERE
  ---------------------------*/
  /*-------------------------
  TABLE CSS START HERE
---------------------------*/
  /*-------------------------
    TABLE CSS ENDS HERE
  ---------------------------*/
}
body.release-notes img {
  max-width: 100%;
}
body.release-notes h1 {
  font-size: 2.25rem;
  font-weight: bold;
  line-height: 1.375;
  color: #333;
  margin-top: 0;
}
body.release-notes h4 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.375;
  color: #333;
}
body.release-notes .main-container header {
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  height: 60px;
  padding: 10px 0 23px;
  position: fixed;
  z-index: 1;
  left: 0;
  right: 0;
}
body.release-notes .main-container .sub_header {
  background-color: #f6f6f6;
  box-shadow: 0 1px 3px 0 rgba(67, 55, 55, 0.22);
  padding: 107px 0 27px 0;
}
body.release-notes .nav_icon {
  width: 26px;
  height: 20px;
  position: fixed;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  float: right;
  top: 10px;
  right: 10px;
  padding: 20px 20px 14px 20px;
}
body.release-notes .nav_icon:hover {
  color: #333;
}
body.release-notes .nav_icon span {
  display: block;
  position: absolute;
  height: 3px;
  width: 80%;
  background: #777;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}
body.release-notes .nav_icon span:nth-child(1) {
  top: 8px;
  transform-origin: left center;
}
body.release-notes .nav_icon span:nth-child(2) {
  top: 16px;
  transform-origin: left center;
}
body.release-notes .nav_icon span:nth-child(3) {
  top: 24px;
  transform-origin: left center;
}
body.release-notes .nav_icon.open span:nth-child(1) {
  transform: rotate(45deg);
  top: 5px;
  left: 8px;
}
body.release-notes .nav_icon.open span:nth-child(2) {
  width: 0%;
  opacity: 0;
}
body.release-notes .nav_icon.open span:nth-child(3) {
  transform: rotate(-45deg);
  top: 28px;
  left: 8px;
}
body.release-notes .version_timeline {
  padding-left: 118px;
}
body.release-notes .version_timeline:before {
  position: absolute;
  width: 3px;
  height: 100%;
  content: '';
  background-color: #eeeeee;
  top: 0;
  left: 130px;
  z-index: -1;
}
body.release-notes .post_container {
  padding: 40px 0;
  position: relative;
}
body.release-notes .badge_container {
  display: inline-block;
  position: absolute;
  left: -120px;
  top: 28px;
}
body.release-notes .badge_container .badge {
  border-radius: 3px;
  padding: 5px 10px 5px 25px;
  display: block;
  position: relative;
  top: 0;
  margin-bottom: 10px;
}
body.release-notes .badge_container .badge:before {
  width: 12px;
  height: 12px;
  position: absolute;
  content: '';
  display: inline-block;
}
body.release-notes .badge_container .badge.latest {
  background-color: #ade4ae;
  box-shadow: 0 2px 4px 0 rgba(62, 194, 116, 0.15);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.375;
  color: #4e674f;
  text-transform: uppercase;
}
body.release-notes .badge_container .badge.latest:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 12px;
  left: 10px;
  top: 7px;
}
body.release-notes .badge_container .badge.unread {
  background-color: rgba(255, 158, 52, 0.1);
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1.375;
  color: #ff9e34;
  text-transform: uppercase;
}
body.release-notes .badge_container .badge.unread:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 8px;
  left: 10px;
  top: 9px;
}
body.release-notes .hashtag_version {
  position: relative;
  left: 0;
}
body.release-notes .hashtag_version .hashtag-style {
  display: inline-block;
  background-color: #eeeeee;
  width: 37px;
  height: 37px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 100%;
  text-align: center;
  line-height: 37px;
  position: absolute;
  top: 23px;
  left: -20px;
}
body.release-notes .hashtag_version .hashtag-style:after {
  position: absolute;
  width: 50px;
  height: 3px;
  content: '';
  background-color: #eeeeee;
  top: calc(50% - 1.5px);
  left: 37px;
}
body.release-notes .hashtag_version .hashtag-style a {
  color: #999999;
  text-decoration: none;
  display: block;
}
body.release-notes .version_container {
  background-color: #f8f8f8;
  font-size: 1.5rem;
  line-height: 1.375;
  color: #111111;
  font-weight: bold;
  padding: 12px 20px 16px 25px;
  display: inline-block;
  position: relative;
  left: 67px;
}
body.release-notes .version_container:before {
  position: absolute;
  width: 5px;
  height: 100%;
  content: '';
  background-color: #ff9e34;
  top: 0;
  left: 0;
}
body.release-notes .version_container span {
  font-size: 0.875rem;
  font-weight: 600;
  color: #555555;
  line-height: 1.375;
  display: block;
  padding-top: 4px;
  text-transform: uppercase;
}
body.release-notes .post_content {
  padding-top: 15px;
  padding-left: 67px;
}
body.release-notes .post_content h1 {
  font-size: 2rem;
  color: #0366d6;
  line-height: 1.5;
  font-weight: 600;
}
body.release-notes .post_content h2 {
  color: #24292e;
  font-size: 1.5rem;
  line-height: 1.25;
  font-weight: 700;
  margin-top: 25px;
}
body.release-notes .post_content h3 {
  font-size: 1.25rem;
  line-height: 1.25;
  font-weight: bold;
  padding: 10px 0;
}
body.release-notes .post_content hr {
  height: 1px;
  border-top: 1px solid #ebecef;
  margin-top: 10px;
  margin-bottom: 10px;
}
body.release-notes .post_content p {
  font-size: 1rem;
  line-height: 1.625;
  color: #24292e;
}
body.release-notes .post_content img {
  padding: 10px;
  background: #fff;
  border: 1px solid #dddddd;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}
body.release-notes .post_content ul li {
  margin: 5px 0;
  line-height: 1.625;
}
body.release-notes .unread_messages {
  text-align: center;
  position: relative;
  display: block;
  padding: 20px 0;
}
body.release-notes .unread_messages span {
  background: #fff;
  padding: 2px 20px;
  font-size: 0.875rem;
  color: #ff9e34;
  font-weight: bold;
}
body.release-notes .unread_messages:before {
  background: #ff9e34;
  height: 3px;
  width: 100%;
  content: '';
  position: absolute;
  top: calc(50% - 1.5px);
  left: 0;
  z-index: -1;
}
body.release-notes .sidebar {
  height: 100vh;
  width: 245px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.05);
  display: block;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  overflow: auto;
  padding: 20px 0;
  transition: 0.2s ease-in-out;
}
body.release-notes .sidebar h5 {
  font-size: 1rem;
  font-weight: 600;
  padding-left: 15px;
  margin-top: 0;
}
body.release-notes .sidebar ul {
  margin: 0;
  padding: 0 10px;
}
body.release-notes .sidebar ul li {
  list-style: none;
  position: relative;
  transition: all 0.05s linear;
}
body.release-notes .sidebar ul li.unread:before {
  width: 7px;
  height: 7px;
  background: #ff9e34;
  border-radius: 100%;
  content: '';
  display: inline-block;
  position: absolute;
  top: 18px;
  left: 10px;
}
body.release-notes .sidebar ul li.latest:after {
  padding: 3px 6px;
  background: #ade4ae;
  border-radius: 3px;
  content: 'LATEST';
  font-size: 0.5625rem;
  font-weight: 600;
  color: #4e674f;
  display: inline-block;
  position: absolute;
  top: 12px;
  left: 75px;
  z-index: 0;
}
body.release-notes .sidebar ul li a {
  display: block;
  padding: 10px 0 10px 25px;
  font-size: 0.875rem;
  line-height: 1.625;
  color: #24292e;
  border-bottom: 1px solid #ebecef;
  text-decoration: none;
  transition: all 0.3s linear;
}
body.release-notes .sidebar ul li a:hover {
  background: #f6f6f6;
}
body.release-notes .sidebar ul li a:hover span {
  opacity: 1;
  transition: all 0.05s linear;
  font-style: italic;
}
body.release-notes .sidebar ul li a span {
  color: #999999;
  font-size: 0.6875rem;
  float: right;
  padding-top: 2px;
  padding-right: 10px;
  opacity: 0;
}
body.release-notes .sidebar ul li.active a {
  color: #ff9e34;
  font-weight: bold;
}
body.release-notes .sidebar ul li.active span {
  opacity: 1;
  font-weight: 400;
  font-style: italic;
}
body.release-notes .Subscribe_box {
  position: relative;
  display: inline-block;
  border-radius: 3px;
  background: #eee;
  border: 1px solid #ddd;
  padding: 15px 20px 15px 20px;
  margin-left: 50px;
}
body.release-notes .Subscribe_box p {
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0;
  padding-bottom: 8px;
  color: #333;
}
body.release-notes .Subscribe_box input {
  width: 225px;
  height: 40px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px 5px 5px 5px;
  padding: 5px 10px;
  outline: none;
  font-size: 0.875rem;
  display: inline-block;
  color: #333;
}
body.release-notes .Subscribe_box button {
  width: 100px;
  height: 40px;
  margin-left: 2px;
  background: #ff9e34;
  border: 0;
  border-radius: 5px 5px 5px 5px;
  display: inline-block;
  padding: 8px 10px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  outline: none;
  transition: all 0.1s linear;
}
body.release-notes .Subscribe_box button:hover {
  background-color: #ed9a2a;
}
@media (max-width: 991.98px) {
  body.release-notes .Subscribe_box {
    margin: 0;
    width: 100%;
    margin-top: 10px;
  }
  body.release-notes .Subscribe_box input {
    width: 75%;
  }
  body.release-notes .Subscribe_box button {
    width: 20%;
  }
}
@media (max-width: 767.98px) {
  body.release-notes .version_timeline {
    padding-left: 0;
  }
  body.release-notes .version_timeline:before {
    display: none;
  }
  body.release-notes .hashtag_version .hashtag-style {
    display: none;
  }
  body.release-notes .hashtag_version .version_container {
    left: 0;
  }
  body.release-notes .post_content {
    padding-left: 0;
  }
  body.release-notes .badge_container {
    left: 250px;
    top: 0;
    display: inline-block;
  }
  body.release-notes .Subscribe_box {
    margin: 0;
    width: 100%;
    margin-top: 10px;
  }
  body.release-notes .Subscribe_box input {
    width: 100%;
  }
  body.release-notes .Subscribe_box button {
    width: 100%;
    margin-top: 10px;
  }
}
@media (max-width: 575.98px) {
  body.release-notes .badge_container {
    position: relative;
    left: 0;
    top: 0;
    display: block;
  }
  body.release-notes .badge_container .badge {
    display: inline-block;
    margin-right: 10px;
  }
}
body.release-notes table {
  width: 100%;
  display: block;
  margin-bottom: 16px;
  overflow: auto;
  font-size: 1rem;
}
body.release-notes table tr {
  background-color: #fff;
  border-top: 1px solid #c6cbd1;
}
body.release-notes table tr:nth-child(2n) {
  background-color: #f6f8fa;
}
body.release-notes table th,
body.release-notes table td {
  padding: 7px 14px;
  border: 1px solid #dfe2e5;
}
body.release-notes table th {
  font-weight: 600;
  text-align: center;
}
/*# sourceMappingURL=release-notes.css.map */`, "",{"version":3,"sources":["webpack://./release-notes.less","webpack://./src/less/release-notes.less"],"names":[],"mappings":"AAOA;EACE,wEAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;ECNA;;4BAE0B;EAC1B;;0BAEwB;EACxB;;8BAE4B;EAC5B;;4BAE0B;EAC1B;;8BAE4B;AAC9B;ADbA;EAOI,eAAA;ACSJ;ADhBA;EAWI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;ACQJ;ADvBA;EAmBI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;ACOJ;AD7BA;EA2BM,sBAAA;EACA,2CAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;ACKN;ADvCA;EAsCM,yBAAA;EACA,8CAAA;EACA,uBAAA;ACIN;AD5CA;EA+CI,WAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;ACAJ;ADCI;EACE,WAAA;ACCN;AD3DA;EA+DI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,uBAAA;EACA,6BAAA;ACDJ;ADvEA;EA4EI,QAAA;EACA,6BAAA;ACFJ;AD3EA;EAiFI,SAAA;EACA,6BAAA;ACHJ;AD/EA;EAsFI,SAAA;EACA,6BAAA;ACJJ;ADnFA;EA2FI,wBAAA;EACA,QAAA;EACA,SAAA;ACLJ;ADxFA;EAiGI,SAAA;EACA,UAAA;ACNJ;AD5FA;EAsGI,yBAAA;EACA,SAAA;EACA,SAAA;ACPJ;ADjGA;EAgHI,mBAAA;ACZJ;ADcI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;ACZN;AD9GA;EA+HI,eAAA;EACA,kBAAA;ACdJ;ADlHA;EAoII,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;ACfJ;ADxHA;EA0IM,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;ACfN;ADiBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;ACfR;ADkBM;EACE,yBAAA;EACA,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AChBR;ADkBQ;EACE,yDAAA;EACA,4BAAA;EACA,qBAAA;EACA,UAAA;EACA,QAAA;AChBV;ADoBM;EACE,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AClBR;ADoBQ;EACE,yDAAA;EACA,4BAAA;EACA,oBAAA;EACA,UAAA;EACA,QAAA;AClBV;ADtKA;EA+LI,kBAAA;EACA,OAAA;ACtBJ;AD1KA;EAmMM,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;ACtBN;ADwBM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;ACtBR;ADjMA;EA2NQ,cAAA;EACA,qBAAA;EACA,cAAA;ACvBR;ADtMA;EAmOI,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AC1BJ;AD4BI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,MAAA;EACA,OAAA;AC1BN;AD1NA;EAwPM,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AC3BN;ADnOA;EAmQI,iBAAA;EACA,kBAAA;AC7BJ;ADvOA;EAuQM,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AC7BN;AD7OA;EA8QM,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AC9BN;ADpPA;EAsRM,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AC/BN;AD1PA;EA6RM,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;AChCN;ADhQA;EAoSM,eAAA;EACA,kBAAA;EACA,cAAA;ACjCN;ADrQA;EA0SM,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,wCAAA;EACA,mBAAA;AClCN;AD5QA;EAmTQ,aAAA;EACA,kBAAA;ACpCR;ADhRA;EA0TI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;ACvCJ;ADtRA;EAgUM,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;ACvCN;AD0CI;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,OAAA;EACA,WAAA;ACxCN;ADvSA;EAoVI,aAAA;EACA,YAAA;EACA,0CAAA;EACA,4CAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;AC1CJ;ADrTA;EAwWM,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AChDN;AD3TA;EA+WM,SAAA;EACA,eAAA;ACjDN;AD/TA;EAmXQ,gBAAA;EACA,kBAAA;EACA,4BAAA;ACjDR;ADmDQ;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;ACjDV;ADoDQ;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AClDV;AD7VA;EAmZU,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,qBAAA;EACA,2BAAA;ACnDV;ADqDU;EACE,mBAAA;ACnDZ;ADkDU;EAII,UAAA;EACA,4BAAA;EACA,kBAAA;ACnDd;AD/WA;EAwaY,cAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;ACtDZ;AD0DQ;EAEI,cAAA;EACA,iBAAA;ACzDZ;ADsDQ;EAOI,UAAA;EACA,gBAAA;EACA,kBAAA;AC1DZ;ADhYA;EAkcI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,iBAAA;AC/DJ;ADzYA;EA2cM,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AC/DN;ADhZA;EAmdM,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AChEN;AD5ZA;EAgeM,YAAA;EACA,YAAA;EAEA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,2BAAA;AClEN;ADoEM;EACE,yBAAA;AClER;ADiFE;EAAA;IAEI,SAAA;IACA,WAAA;IACA,gBAAA;EC/EJ;ED2EA;IAOM,UAAA;EC/EN;EDwEA;IAWM,UAAA;EChFN;AACF;ADoFE;EAAA;IAEI,eAAA;EClFJ;EDoFI;IACE,aAAA;EClFN;ED6EA;IAWM,aAAA;ECrFN;ED0EA;IAeM,OAAA;ECtFN;EDuEA;IAoBI,eAAA;ECxFJ;EDoEA;IAwBI,WAAA;IACA,MAAA;IACA,qBAAA;ECzFJ;ED+DA;IA8BI,SAAA;IACA,WAAA;IACA,gBAAA;EC1FJ;ED0DA;IAmCM,WAAA;EC1FN;EDuDA;IAuCM,WAAA;IACA,gBAAA;EC3FN;AACF;AD+FE;EAAA;IAEI,kBAAA;IACA,OAAA;IACA,MAAA;IACA,cAAA;EC7FJ;EDwFA;IAQM,qBAAA;IACA,kBAAA;EC7FN;AACF;AD1eA;EA+kBI,WAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AClGJ;ADjfA;EAqlBM,sBAAA;EACA,6BAAA;ACjGN;ADkGM;EACE,yBAAA;AChGR;ADxfA;;EA6lBM,iBAAA;EACA,yBAAA;ACjGN;AD7fA;EAimBM,gBAAA;EACA,kBAAA;ACjGN;AACA,4CAA4C","sourcesContent":["@import 'app/custom-variables.less';\n\n@white-color: #fff;\n@black-color: #333;\n@primary-color: #ff9e34;\n@sidebar-width: 245px;\n\nbody.release-notes {\n  font-family: @font-family-sans-serif;\n  font-size: 1em !important;\n  color: @black-color;\n  word-wrap: break-word;\n\n  img {\n    max-width: 100%;\n  }\n\n  h1 {\n    font-size: 2.25rem;\n    font-weight: bold;\n    line-height: 1.375;\n    color: @black-color;\n    margin-top: 0;\n  }\n\n  h4 {\n    font-size: 1rem;\n    font-weight: 600;\n    line-height: 1.375;\n    color: @black-color;\n  }\n\n  .main-container {\n    header {\n      background-color: @white-color;\n      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);\n      height: 60px;\n      padding: 10px 0 23px;\n      position: fixed;\n      z-index: 1;\n      left: 0;\n      right: 0;\n    }\n\n    .sub_header {\n      background-color: #f6f6f6;\n      box-shadow: 0 1px 3px 0 rgba(67, 55, 55, 0.22);\n      padding: 107px 0 27px 0;\n    }\n  }\n  /* -------------------------\n      NAV ICON CSS\n  -------------------------*/\n  .nav_icon {\n    width: 26px;\n    height: 20px;\n    position: fixed;\n    transform: rotate(0deg);\n    transition: 0.5s ease-in-out;\n    cursor: pointer;\n    float: right;\n    top: 10px;\n    right: 10px;\n    padding: 20px 20px 14px 20px;\n    &:hover {\n      color: #333;\n    }\n  }\n\n  .nav_icon span {\n    display: block;\n    position: absolute;\n    height: 3px;\n    width: 80%;\n    background: #777;\n    border-radius: 9px;\n    opacity: 1;\n    left: 0;\n    transform: rotate(0deg);\n    transition: 0.25s ease-in-out;\n  }\n\n  .nav_icon span:nth-child(1) {\n    top: 8px;\n    transform-origin: left center;\n  }\n\n  .nav_icon span:nth-child(2) {\n    top: 16px;\n    transform-origin: left center;\n  }\n\n  .nav_icon span:nth-child(3) {\n    top: 24px;\n    transform-origin: left center;\n  }\n\n  .nav_icon.open span:nth-child(1) {\n    transform: rotate(45deg);\n    top: 5px;\n    left: 8px;\n  }\n\n  .nav_icon.open span:nth-child(2) {\n    width: 0%;\n    opacity: 0;\n  }\n\n  .nav_icon.open span:nth-child(3) {\n    transform: rotate(-45deg);\n    top: 28px;\n    left: 8px;\n  }\n\n  /* -------------------------\n    NAV ICON CSS END\n-------------------------*/\n\n  .version_timeline {\n    padding-left: 118px;\n\n    &:before {\n      position: absolute;\n      width: 3px;\n      height: 100%;\n      content: '';\n      background-color: #eeeeee;\n      top: 0;\n      left: 130px;\n      z-index: -1;\n    }\n  }\n\n  .post_container {\n    padding: 40px 0;\n    position: relative;\n  }\n\n  .badge_container {\n    display: inline-block;\n    position: absolute;\n    left: -120px;\n    top: 28px;\n\n    .badge {\n      border-radius: 3px;\n      padding: 5px 10px 5px 25px;\n      display: block;\n      position: relative;\n      top: 0;\n      margin-bottom: 10px;\n\n      &:before {\n        width: 12px;\n        height: 12px;\n        position: absolute;\n        content: '';\n        display: inline-block;\n      }\n\n      &.latest {\n        background-color: #ade4ae;\n        box-shadow: 0 2px 4px 0 rgba(62, 194, 116, 0.15);\n        font-size: 0.75rem;\n        font-weight: 600;\n        line-height: 1.375;\n        color: #4e674f;\n        text-transform: uppercase;\n\n        &:before {\n          background-image: url(../img/ui/star.svg);\n          background-repeat: no-repeat;\n          background-size: 12px;\n          left: 10px;\n          top: 7px;\n        }\n      }\n\n      &.unread {\n        background-color: rgba(@primary-color, 0.1);\n        font-size: 0.75rem;\n        font-weight: bold;\n        line-height: 1.375;\n        color: @primary-color;\n        text-transform: uppercase;\n\n        &:before {\n          background-image: url(../img/ui/oval.svg);\n          background-repeat: no-repeat;\n          background-size: 8px;\n          left: 10px;\n          top: 9px;\n        }\n      }\n    }\n  }\n\n  .hashtag_version {\n    position: relative;\n    left: 0;\n\n    .hashtag-style {\n      display: inline-block;\n      background-color: #eeeeee;\n      width: 37px;\n      height: 37px;\n      font-size: 1rem;\n      font-weight: 600;\n      border-radius: 100%;\n      text-align: center;\n      line-height: 37px;\n      position: absolute;\n      top: 23px;\n      left: -20px;\n\n      &:after {\n        position: absolute;\n        width: 50px;\n        height: 3px;\n        content: '';\n        background-color: #eeeeee;\n        top: calc(50% - 1.5px);\n        left: 37px;\n      }\n\n      a {\n        color: #999999;\n        text-decoration: none;\n        display: block;\n      }\n    }\n  }\n\n  .version_container {\n    background-color: #f8f8f8;\n    font-size: 1.5rem;\n    line-height: 1.375;\n    color: #111111;\n    font-weight: bold;\n    padding: 12px 20px 16px 25px;\n    display: inline-block;\n    position: relative;\n    left: 67px;\n\n    &:before {\n      position: absolute;\n      width: 5px;\n      height: 100%;\n      content: '';\n      background-color: @primary-color;\n      top: 0;\n      left: 0;\n    }\n\n    span {\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: #555555;\n      line-height: 1.375;\n      display: block;\n      padding-top: 4px;\n      text-transform: uppercase;\n    }\n  }\n\n  .post_content {\n    padding-top: 15px;\n    padding-left: 67px;\n\n    h1 {\n      font-size: 2rem;\n      color: #0366d6;\n      line-height: 1.5;\n      font-weight: 600;\n    }\n\n    h2 {\n      color: #24292e;\n      font-size: 1.5rem;\n      line-height: 1.25;\n      font-weight: 700;\n      margin-top: 25px;\n    }\n\n    h3 {\n      font-size: 1.25rem;\n      line-height: 1.25;\n      font-weight: bold;\n      padding: 10px 0;\n    }\n\n    hr {\n      height: 1px;\n      border-top: 1px solid #ebecef;\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n\n    p {\n      font-size: 1rem;\n      line-height: 1.625;\n      color: #24292e;\n    }\n\n    img {\n      padding: 10px;\n      background: @white-color;\n      border: 1px solid #dddddd;\n      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);\n      margin-bottom: 10px;\n    }\n\n    ul {\n      li {\n        margin: 5px 0;\n        line-height: 1.625;\n      }\n    }\n  }\n\n  .unread_messages {\n    text-align: center;\n    position: relative;\n    display: block;\n    padding: 20px 0;\n\n    span {\n      background: @white-color;\n      padding: 2px 20px;\n      font-size: 0.875rem;\n      color: @primary-color;\n      font-weight: bold;\n    }\n\n    &:before {\n      background: @primary-color;\n      height: 3px;\n      width: 100%;\n      content: '';\n      position: absolute;\n      top: calc(50% - 1.5px);\n      left: 0;\n      z-index: -1;\n    }\n  }\n\n  .sidebar {\n    height: 100vh;\n    width: 245px;\n    background-color: rgba(255, 255, 255, 0.9);\n    box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.05);\n    display: block;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 2;\n    overflow: auto;\n    padding: 20px 0;\n    transition: 0.2s ease-in-out;\n    // &.sidebar-close {\n    //   right: -245px;\n    // }\n    // &.sidebar-open {\n    //   right: 0;\n    //\n    // }\n    h5 {\n      font-size: 1rem;\n      font-weight: 600;\n      padding-left: 15px;\n      margin-top: 0;\n    }\n\n    ul {\n      margin: 0;\n      padding: 0 10px;\n\n      li {\n        list-style: none;\n        position: relative;\n        transition: all 0.05s linear;\n\n        &.unread:before {\n          width: 7px;\n          height: 7px;\n          background: @primary-color;\n          border-radius: 100%;\n          content: '';\n          display: inline-block;\n          position: absolute;\n          top: 18px;\n          left: 10px;\n        }\n\n        &.latest:after {\n          padding: 3px 6px;\n          background: #ade4ae;\n          border-radius: 3px;\n          content: 'LATEST';\n          font-size: 0.5625rem;\n          font-weight: 600;\n          color: #4e674f;\n          display: inline-block;\n          position: absolute;\n          top: 12px;\n          left: 75px;\n          z-index: 0;\n        }\n\n        a {\n          display: block;\n          padding: 10px 0 10px 25px;\n          font-size: 0.875rem;\n          line-height: 1.625;\n          color: #24292e;\n          border-bottom: 1px solid #ebecef;\n          text-decoration: none;\n          transition: all 0.3s linear;\n\n          &:hover {\n            background: #f6f6f6;\n\n            span {\n              opacity: 1;\n              transition: all 0.05s linear;\n              font-style: italic;\n              // text-transform: uppercase;\n            }\n          }\n\n          span {\n            color: #999999;\n            font-size: 0.6875rem;\n            float: right;\n            padding-top: 2px;\n            padding-right: 10px;\n            opacity: 0;\n          }\n        }\n\n        &.active {\n          a {\n            color: @primary-color;\n            font-weight: bold;\n          }\n\n          span {\n            opacity: 1;\n            font-weight: 400;\n            font-style: italic;\n          }\n        }\n      }\n    }\n  }\n\n  .Subscribe_box {\n    position: relative;\n    display: inline-block;\n    border-radius: 3px;\n    background: #eee;\n    border: 1px solid #ddd;\n    padding: 15px 20px 15px 20px;\n    margin-left: 50px;\n\n    p {\n      font-size: 0.875rem;\n      font-weight: 700;\n      margin: 0;\n      padding-bottom: 8px;\n      color: @black-color;\n    }\n\n    input {\n      width: 225px;\n      height: 40px;\n      background: @white-color;\n      border: 1px solid #ddd;\n      border-radius: 5px 5px 5px 5px;\n      padding: 5px 10px;\n      outline: none;\n      font-size: 0.875rem;\n      display: inline-block;\n      color: @black-color;\n    }\n\n    button {\n      width: 100px;\n      height: 40px;\n      display: inline-block;\n      margin-left: 2px;\n      background: @primary-color;\n      border: 0;\n      border-radius: 5px 5px 5px 5px;\n      display: inline-block;\n      padding: 8px 10px;\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: @white-color;\n      text-transform: uppercase;\n      outline: none;\n      transition: all 0.1s linear;\n\n      &:hover {\n        background-color: #ed9a2a;\n      }\n    }\n  }\n\n  /*-------------------------\n    RESPONSIVE CSS START HERE\n  ---------------------------*/\n\n  @media (max-width: 1330px) {\n  }\n\n  @media (max-width: 1199.98px) {\n  }\n\n  @media (max-width: 991.98px) {\n    .Subscribe_box {\n      margin: 0;\n      width: 100%;\n      margin-top: 10px;\n\n      input {\n        width: 75%;\n      }\n\n      button {\n        width: 20%;\n      }\n    }\n  }\n\n  @media (max-width: 767.98px) {\n    .version_timeline {\n      padding-left: 0;\n\n      &:before {\n        display: none;\n      }\n    }\n\n    .hashtag_version {\n      .hashtag-style {\n        display: none;\n      }\n\n      .version_container {\n        left: 0;\n      }\n    }\n\n    .post_content {\n      padding-left: 0;\n    }\n\n    .badge_container {\n      left: 250px;\n      top: 0;\n      display: inline-block;\n    }\n\n    .Subscribe_box {\n      margin: 0;\n      width: 100%;\n      margin-top: 10px;\n\n      input {\n        width: 100%;\n      }\n\n      button {\n        width: 100%;\n        margin-top: 10px;\n      }\n    }\n  }\n\n  @media (max-width: 575.98px) {\n    .badge_container {\n      position: relative;\n      left: 0;\n      top: 0;\n      display: block;\n\n      .badge {\n        display: inline-block;\n        margin-right: 10px;\n      }\n    }\n  }\n\n  /*-------------------------\n  TABLE CSS START HERE\n---------------------------*/\n  table {\n    width: 100%;\n    display: block;\n    margin-bottom: 16px;\n    overflow: auto;\n    font-size: 1rem;\n    tr {\n      background-color: #fff;\n      border-top: 1px solid #c6cbd1;\n      &:nth-child(2n) {\n        background-color: #f6f8fa;\n      }\n    }\n    th,\n    td {\n      padding: 7px 14px;\n      border: 1px solid #dfe2e5;\n    }\n    th {\n      font-weight: 600;\n      text-align: center;\n    }\n  }\n  /*-------------------------\n    TABLE CSS ENDS HERE\n  ---------------------------*/\n}\n","body.release-notes {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 1em !important;\n  color: #333;\n  word-wrap: break-word;\n  /* -------------------------\n      NAV ICON CSS\n  -------------------------*/\n  /* -------------------------\n    NAV ICON CSS END\n-------------------------*/\n  /*-------------------------\n    RESPONSIVE CSS START HERE\n  ---------------------------*/\n  /*-------------------------\n  TABLE CSS START HERE\n---------------------------*/\n  /*-------------------------\n    TABLE CSS ENDS HERE\n  ---------------------------*/\n}\nbody.release-notes img {\n  max-width: 100%;\n}\nbody.release-notes h1 {\n  font-size: 2.25rem;\n  font-weight: bold;\n  line-height: 1.375;\n  color: #333;\n  margin-top: 0;\n}\nbody.release-notes h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.375;\n  color: #333;\n}\nbody.release-notes .main-container header {\n  background-color: #fff;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);\n  height: 60px;\n  padding: 10px 0 23px;\n  position: fixed;\n  z-index: 1;\n  left: 0;\n  right: 0;\n}\nbody.release-notes .main-container .sub_header {\n  background-color: #f6f6f6;\n  box-shadow: 0 1px 3px 0 rgba(67, 55, 55, 0.22);\n  padding: 107px 0 27px 0;\n}\nbody.release-notes .nav_icon {\n  width: 26px;\n  height: 20px;\n  position: fixed;\n  transform: rotate(0deg);\n  transition: 0.5s ease-in-out;\n  cursor: pointer;\n  float: right;\n  top: 10px;\n  right: 10px;\n  padding: 20px 20px 14px 20px;\n}\nbody.release-notes .nav_icon:hover {\n  color: #333;\n}\nbody.release-notes .nav_icon span {\n  display: block;\n  position: absolute;\n  height: 3px;\n  width: 80%;\n  background: #777;\n  border-radius: 9px;\n  opacity: 1;\n  left: 0;\n  transform: rotate(0deg);\n  transition: 0.25s ease-in-out;\n}\nbody.release-notes .nav_icon span:nth-child(1) {\n  top: 8px;\n  transform-origin: left center;\n}\nbody.release-notes .nav_icon span:nth-child(2) {\n  top: 16px;\n  transform-origin: left center;\n}\nbody.release-notes .nav_icon span:nth-child(3) {\n  top: 24px;\n  transform-origin: left center;\n}\nbody.release-notes .nav_icon.open span:nth-child(1) {\n  transform: rotate(45deg);\n  top: 5px;\n  left: 8px;\n}\nbody.release-notes .nav_icon.open span:nth-child(2) {\n  width: 0%;\n  opacity: 0;\n}\nbody.release-notes .nav_icon.open span:nth-child(3) {\n  transform: rotate(-45deg);\n  top: 28px;\n  left: 8px;\n}\nbody.release-notes .version_timeline {\n  padding-left: 118px;\n}\nbody.release-notes .version_timeline:before {\n  position: absolute;\n  width: 3px;\n  height: 100%;\n  content: '';\n  background-color: #eeeeee;\n  top: 0;\n  left: 130px;\n  z-index: -1;\n}\nbody.release-notes .post_container {\n  padding: 40px 0;\n  position: relative;\n}\nbody.release-notes .badge_container {\n  display: inline-block;\n  position: absolute;\n  left: -120px;\n  top: 28px;\n}\nbody.release-notes .badge_container .badge {\n  border-radius: 3px;\n  padding: 5px 10px 5px 25px;\n  display: block;\n  position: relative;\n  top: 0;\n  margin-bottom: 10px;\n}\nbody.release-notes .badge_container .badge:before {\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  content: '';\n  display: inline-block;\n}\nbody.release-notes .badge_container .badge.latest {\n  background-color: #ade4ae;\n  box-shadow: 0 2px 4px 0 rgba(62, 194, 116, 0.15);\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.375;\n  color: #4e674f;\n  text-transform: uppercase;\n}\nbody.release-notes .badge_container .badge.latest:before {\n  background-image: url(../img/ui/star.svg);\n  background-repeat: no-repeat;\n  background-size: 12px;\n  left: 10px;\n  top: 7px;\n}\nbody.release-notes .badge_container .badge.unread {\n  background-color: rgba(255, 158, 52, 0.1);\n  font-size: 0.75rem;\n  font-weight: bold;\n  line-height: 1.375;\n  color: #ff9e34;\n  text-transform: uppercase;\n}\nbody.release-notes .badge_container .badge.unread:before {\n  background-image: url(../img/ui/oval.svg);\n  background-repeat: no-repeat;\n  background-size: 8px;\n  left: 10px;\n  top: 9px;\n}\nbody.release-notes .hashtag_version {\n  position: relative;\n  left: 0;\n}\nbody.release-notes .hashtag_version .hashtag-style {\n  display: inline-block;\n  background-color: #eeeeee;\n  width: 37px;\n  height: 37px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 100%;\n  text-align: center;\n  line-height: 37px;\n  position: absolute;\n  top: 23px;\n  left: -20px;\n}\nbody.release-notes .hashtag_version .hashtag-style:after {\n  position: absolute;\n  width: 50px;\n  height: 3px;\n  content: '';\n  background-color: #eeeeee;\n  top: calc(50% - 1.5px);\n  left: 37px;\n}\nbody.release-notes .hashtag_version .hashtag-style a {\n  color: #999999;\n  text-decoration: none;\n  display: block;\n}\nbody.release-notes .version_container {\n  background-color: #f8f8f8;\n  font-size: 1.5rem;\n  line-height: 1.375;\n  color: #111111;\n  font-weight: bold;\n  padding: 12px 20px 16px 25px;\n  display: inline-block;\n  position: relative;\n  left: 67px;\n}\nbody.release-notes .version_container:before {\n  position: absolute;\n  width: 5px;\n  height: 100%;\n  content: '';\n  background-color: #ff9e34;\n  top: 0;\n  left: 0;\n}\nbody.release-notes .version_container span {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #555555;\n  line-height: 1.375;\n  display: block;\n  padding-top: 4px;\n  text-transform: uppercase;\n}\nbody.release-notes .post_content {\n  padding-top: 15px;\n  padding-left: 67px;\n}\nbody.release-notes .post_content h1 {\n  font-size: 2rem;\n  color: #0366d6;\n  line-height: 1.5;\n  font-weight: 600;\n}\nbody.release-notes .post_content h2 {\n  color: #24292e;\n  font-size: 1.5rem;\n  line-height: 1.25;\n  font-weight: 700;\n  margin-top: 25px;\n}\nbody.release-notes .post_content h3 {\n  font-size: 1.25rem;\n  line-height: 1.25;\n  font-weight: bold;\n  padding: 10px 0;\n}\nbody.release-notes .post_content hr {\n  height: 1px;\n  border-top: 1px solid #ebecef;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\nbody.release-notes .post_content p {\n  font-size: 1rem;\n  line-height: 1.625;\n  color: #24292e;\n}\nbody.release-notes .post_content img {\n  padding: 10px;\n  background: #fff;\n  border: 1px solid #dddddd;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n}\nbody.release-notes .post_content ul li {\n  margin: 5px 0;\n  line-height: 1.625;\n}\nbody.release-notes .unread_messages {\n  text-align: center;\n  position: relative;\n  display: block;\n  padding: 20px 0;\n}\nbody.release-notes .unread_messages span {\n  background: #fff;\n  padding: 2px 20px;\n  font-size: 0.875rem;\n  color: #ff9e34;\n  font-weight: bold;\n}\nbody.release-notes .unread_messages:before {\n  background: #ff9e34;\n  height: 3px;\n  width: 100%;\n  content: '';\n  position: absolute;\n  top: calc(50% - 1.5px);\n  left: 0;\n  z-index: -1;\n}\nbody.release-notes .sidebar {\n  height: 100vh;\n  width: 245px;\n  background-color: rgba(255, 255, 255, 0.9);\n  box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.05);\n  display: block;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 2;\n  overflow: auto;\n  padding: 20px 0;\n  transition: 0.2s ease-in-out;\n}\nbody.release-notes .sidebar h5 {\n  font-size: 1rem;\n  font-weight: 600;\n  padding-left: 15px;\n  margin-top: 0;\n}\nbody.release-notes .sidebar ul {\n  margin: 0;\n  padding: 0 10px;\n}\nbody.release-notes .sidebar ul li {\n  list-style: none;\n  position: relative;\n  transition: all 0.05s linear;\n}\nbody.release-notes .sidebar ul li.unread:before {\n  width: 7px;\n  height: 7px;\n  background: #ff9e34;\n  border-radius: 100%;\n  content: '';\n  display: inline-block;\n  position: absolute;\n  top: 18px;\n  left: 10px;\n}\nbody.release-notes .sidebar ul li.latest:after {\n  padding: 3px 6px;\n  background: #ade4ae;\n  border-radius: 3px;\n  content: 'LATEST';\n  font-size: 0.5625rem;\n  font-weight: 600;\n  color: #4e674f;\n  display: inline-block;\n  position: absolute;\n  top: 12px;\n  left: 75px;\n  z-index: 0;\n}\nbody.release-notes .sidebar ul li a {\n  display: block;\n  padding: 10px 0 10px 25px;\n  font-size: 0.875rem;\n  line-height: 1.625;\n  color: #24292e;\n  border-bottom: 1px solid #ebecef;\n  text-decoration: none;\n  transition: all 0.3s linear;\n}\nbody.release-notes .sidebar ul li a:hover {\n  background: #f6f6f6;\n}\nbody.release-notes .sidebar ul li a:hover span {\n  opacity: 1;\n  transition: all 0.05s linear;\n  font-style: italic;\n}\nbody.release-notes .sidebar ul li a span {\n  color: #999999;\n  font-size: 0.6875rem;\n  float: right;\n  padding-top: 2px;\n  padding-right: 10px;\n  opacity: 0;\n}\nbody.release-notes .sidebar ul li.active a {\n  color: #ff9e34;\n  font-weight: bold;\n}\nbody.release-notes .sidebar ul li.active span {\n  opacity: 1;\n  font-weight: 400;\n  font-style: italic;\n}\nbody.release-notes .Subscribe_box {\n  position: relative;\n  display: inline-block;\n  border-radius: 3px;\n  background: #eee;\n  border: 1px solid #ddd;\n  padding: 15px 20px 15px 20px;\n  margin-left: 50px;\n}\nbody.release-notes .Subscribe_box p {\n  font-size: 0.875rem;\n  font-weight: 700;\n  margin: 0;\n  padding-bottom: 8px;\n  color: #333;\n}\nbody.release-notes .Subscribe_box input {\n  width: 225px;\n  height: 40px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 5px 5px 5px 5px;\n  padding: 5px 10px;\n  outline: none;\n  font-size: 0.875rem;\n  display: inline-block;\n  color: #333;\n}\nbody.release-notes .Subscribe_box button {\n  width: 100px;\n  height: 40px;\n  margin-left: 2px;\n  background: #ff9e34;\n  border: 0;\n  border-radius: 5px 5px 5px 5px;\n  display: inline-block;\n  padding: 8px 10px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #fff;\n  text-transform: uppercase;\n  outline: none;\n  transition: all 0.1s linear;\n}\nbody.release-notes .Subscribe_box button:hover {\n  background-color: #ed9a2a;\n}\n@media (max-width: 991.98px) {\n  body.release-notes .Subscribe_box {\n    margin: 0;\n    width: 100%;\n    margin-top: 10px;\n  }\n  body.release-notes .Subscribe_box input {\n    width: 75%;\n  }\n  body.release-notes .Subscribe_box button {\n    width: 20%;\n  }\n}\n@media (max-width: 767.98px) {\n  body.release-notes .version_timeline {\n    padding-left: 0;\n  }\n  body.release-notes .version_timeline:before {\n    display: none;\n  }\n  body.release-notes .hashtag_version .hashtag-style {\n    display: none;\n  }\n  body.release-notes .hashtag_version .version_container {\n    left: 0;\n  }\n  body.release-notes .post_content {\n    padding-left: 0;\n  }\n  body.release-notes .badge_container {\n    left: 250px;\n    top: 0;\n    display: inline-block;\n  }\n  body.release-notes .Subscribe_box {\n    margin: 0;\n    width: 100%;\n    margin-top: 10px;\n  }\n  body.release-notes .Subscribe_box input {\n    width: 100%;\n  }\n  body.release-notes .Subscribe_box button {\n    width: 100%;\n    margin-top: 10px;\n  }\n}\n@media (max-width: 575.98px) {\n  body.release-notes .badge_container {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n  }\n  body.release-notes .badge_container .badge {\n    display: inline-block;\n    margin-right: 10px;\n  }\n}\nbody.release-notes table {\n  width: 100%;\n  display: block;\n  margin-bottom: 16px;\n  overflow: auto;\n  font-size: 1rem;\n}\nbody.release-notes table tr {\n  background-color: #fff;\n  border-top: 1px solid #c6cbd1;\n}\nbody.release-notes table tr:nth-child(2n) {\n  background-color: #f6f8fa;\n}\nbody.release-notes table th,\nbody.release-notes table td {\n  padding: 7px 14px;\n  border: 1px solid #dfe2e5;\n}\nbody.release-notes table th {\n  font-weight: 600;\n  text-align: center;\n}\n/*# sourceMappingURL=release-notes.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
